import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	dateFilterTitle: {
		id: 'dynamic-cards-search-page.date.filter.title',
		defaultMessage: 'Last updated',
		description: 'Filter by the date content was modified',
	},
	dateFilterFromTitle: {
		id: 'dynamic-cards-search-page.date.filter.from.title',
		defaultMessage: 'From',
		description: 'Filter starting from a custom date',
	},
	dateFilterToTitle: {
		id: 'dynamic-cards-search-page.date.filter.to.title',
		defaultMessage: 'To',
		description: 'Filter up to a custom date',
	},
	dateFilterDateInputPlaceholder: {
		id: 'dynamic-cards-search-page.date.filter.input.placeholder',
		defaultMessage: 'Choose a date',
		description: 'Placeholder text for date input',
	},
	dateFilterAnyTime: {
		id: 'dynamic-cards-search-page.date.filter.any.time',
		defaultMessage: 'Anytime',
		description: 'Option to show content from any time',
	},
	dateFilterToday: {
		id: 'dynamic-cards-search-page.date.filter.today',
		defaultMessage: 'Today',
		description: 'Date range of content modified today',
	},
	dateFilterYesterday: {
		id: 'dynamic-cards-search-page.date.filter.yesterday',
		defaultMessage: 'Yesterday',
		description: 'Date range of content modified yesterday',
	},
	dateFilterLastWeek: {
		id: 'dynamic-cards-search-page.date.filter.last.week',
		defaultMessage: 'Past 7 days',
		description: 'Date range of content modified in the last 7 days',
	},
	dateFilterLastMonth: {
		id: 'dynamic-cards-search-page.date.filter.last.month',
		defaultMessage: 'Past 30 days',
		description: 'Date range of content modified in the last 30 days',
	},
	dateFilterLastYear: {
		id: 'dynamic-cards-search-page.date.filter.last.year',
		defaultMessage: 'Past year',
		description: 'Date range of content modified in the last 365 days',
	},
	dateFilterCustom: {
		id: 'dynamic-cards-search-page.date.filter.custom',
		defaultMessage: 'Custom',
		description: 'Custom date range',
	},
	dateFilterCustomInvalidDateAfterToday: {
		id: 'dynamic-cards-search-page.date.filter.custom.invalid.after.today',
		defaultMessage: 'The From date can’t be in the future',
		description: 'error displayed when a date range begins after the current date',
	},
	dateFilterCustomInvalidToDateAfterToday: {
		id: 'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today',
		defaultMessage: 'The To date can’t be in the future',
		description: 'error displayed when a date range ends after the current date',
	},
	dateFilterCustomInvalidDateAfterEnd: {
		id: 'dynamic-cards-search-page.date.filter.custom.invalid.after.end',
		defaultMessage: 'The From date has to be before the To date',
		description: 'error displayed when a date range begins after the end date',
	},
	dateFilterToRange: {
		id: 'dynamic-cards-search-page.date.filter.to.range',
		defaultMessage: 'to',
		description: "'to' in between from and to date pickers",
	},
	dateFilterUpdateButton: {
		id: 'dynamic-cards-search-page.date.filter.update.button',
		defaultMessage: 'Update',
		description: 'Text for update button in date filter picker',
	},
	dateFilterBeforeLabel: {
		id: 'dynamic-cards-search-page.date.filter.before.label',
		defaultMessage: 'before',
		description: '`before` for date picker dropdown',
	},
	dateFilterAfterLabel: {
		id: 'dynamic-cards-search-page.date.filter.after.label',
		defaultMessage: 'after',
		description: '`after` for date picker dropdown',
	},
});
